import {
  Alert,
  Anchor,
  Group,
  Progress,
  Stack,
  Text,
  Tooltip,
} from "@mantine/core";
import { Link } from "react-router-dom";
import { upgradeHref } from "../../utils/searchParams";
import { usePlanUsage } from "../../utils/usePlanUsage";
import { Can } from "../auth/Can";
import classes from "./PlanUsageBanner.module.css";

export function PlanUsageBanner({ navCollapsed }: { navCollapsed: boolean }) {
  const { warnings } = usePlanUsage();

  const items = [
    { label: "Facts", usage: warnings.facts },
    { label: "Contacts", usage: warnings.contacts },
    { label: "API keys", usage: warnings.apiKeys },
    { label: "Agent API keys", usage: warnings.agentKeys },
  ].flatMap(({ label, usage }) =>
    usage
      ? [
          {
            label,
            ...usage,
            percent: Math.min(
              100,
              Math.round((usage.used / usage.limit) * 100),
            ),
          },
        ]
      : [],
  );

  if (!items.length) return null;

  const maxPercent = Math.max(...items.map((item) => item.percent));
  const summary = items
    .map(({ label, used, limit }) => `${label} ${used}/${limit}`)
    .join(", ");

  return (
    <Alert className={classes.bannerContainer} color="yellow" p="xs" mt="lg">
      {navCollapsed ? (
        <Tooltip label={summary} position="right">
          <Text size="sm" fw="bold" ta="center" className={classes.bannerText}>
            {maxPercent}%
          </Text>
        </Tooltip>
      ) : (
        <Stack gap="xs">
          {items.map(({ label, used, limit, percent }) => (
            <Stack key={label} gap={4}>
              <Group justify="space-between">
                <Text size="sm" className={classes.bannerText}>
                  {label}
                </Text>
                <Text size="sm" fw="bold" className={classes.bannerText}>
                  {used}/{limit}
                </Text>
              </Group>
              <Progress
                value={percent}
                size="sm"
                color={percent >= 100 ? "red" : "yellow"}
              />
            </Stack>
          ))}
          <Can execute="account.update.billing">
            <Anchor component={Link} to={upgradeHref} size="sm" c="yellow">
              Upgrade for more
            </Anchor>
          </Can>
        </Stack>
      )}
    </Alert>
  );
}
